import { Province } from "./Province";

export class Address {

    private _id: number;
    private _unit: string | null;
    private _street: string | null;
    private _suburb: string | null;
    private _town: string | null;
    private _postal_code: number;
    private _province: Province;

    constructor() {
        this._id = 0;
        this._unit = null;
        this._street = null;
        this._suburb = null;
        this._town = null;
        this._postal_code = 0;
        this._province = new Province();
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get unit(): string | null {
        return this._unit;
    }

    set unit(value: string | null) {
        this._unit = value;
    }

    get street(): string | null {
        return this._street;
    }

    set street(value: string | null) {
        this._street = value;
    }

    get suburb(): string | null {
        return this._suburb;
    }

    set suburb(value: string | null) {
        this._suburb = value;
    }

    get town(): string | null {
        return this._town;
    }

    set town(value: string | null) {
        this._town = value;
    }

    get postal_code(): number {
        return this._postal_code;
    }

    set postal_code(value: number) {
        this._postal_code = value;
    }

    get province(): Province {
        return this._province;
    }

    set province(value: Province) {
        this._province = value;
    }
}